import humps from 'humps';
import notFoundTpl from './templates/404.html';

export default function config(
  $httpProvider,
  $locationProvider,
  $stateProvider,
  ngS3Config,
  localStorageServiceProvider
) {
  $httpProvider.defaults.headers.common['Accept'] = 'application/json';

  let csrfElement = document.querySelector('meta[name=csrf-token]');
  // not there in tests
  if (csrfElement) {
    $httpProvider.defaults.headers.common[
      'X-CSRF-Token'
    ] = csrfElement.getAttribute('content');
  }

  var interceptor = function($q) {
    return {
      request: function(config) {
        if (config.url.match(/^\//)) {
          if (!(config.data && config.data.toString().match(/FormData/))) {
            config.data = humps.decamelizeKeys(config.data);
          }
          config.params = humps.decamelizeKeys(config.params);
        }
        return config;
      },
      response: function(response) {
        response.data = humps.camelizeKeys(response.data);
        return response;
      },
      responseError: function(rejection) {
        return $q.reject(humps.camelizeKeys(rejection));
      }
    };
  };
  interceptor.$inject = ['$q'];
  $httpProvider.interceptors.push(interceptor);

  $locationProvider.html5Mode(true);

  $stateProvider.state('notFound', { template: notFoundTpl });

  ngS3Config.theme = 'bootstrap3';
  localStorageServiceProvider.setPrefix('strNag');
}

config.$inject = [
  '$httpProvider',
  '$locationProvider',
  '$stateProvider',
  'ngS3Config',
  'localStorageServiceProvider'
];
